module.exports = __webpack_public_path__ + "infographic_design_digital_factory_green_mobile_design.png?d0577a4e4a8b866bef5173e33ac048f1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/infographic_design_digital_factory_green_mobile_design.png
// module id = 55
// module chunks = 0